import * as React from 'react';

import { ErrorCannotOrder } from 'app/components/error-cannot-order';
import { i18n } from 'app/i18n';
import { clockImageProps } from 'app/resources/images';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { authorizeActionCreator } from 'app/pages/auth/redux/action-creators/authorize-action-creator';
import { resetOrderStateToInitialActionCreator } from 'app/pages/order/redux/action-creators/reset-order-state-to-initial-action-creator';
import { resetAuthStateToInitialActionCreator } from 'app/pages/auth/redux/action-creators/reset-auth-state-to-initial-action-creator';
import { DataLayerErrorType } from 'app/data-layers/model/data-layer-error-type';

export const SessionExpiredPage: React.FunctionComponent = () => {
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(resetAuthStateToInitialActionCreator());
        dispatch(resetOrderStateToInitialActionCreator());
    }, [dispatch]);

    const handleClick = (): void => {
        dispatch(authorizeActionCreator());
    };

    return (
        <ErrorCannotOrder
            title={i18n.page.error.sessionExpired.title}
            subtitles={[i18n.page.error.sessionExpired.firstSubtitle, i18n.page.error.sessionExpired.secondSubtitle]}
            image={clockImageProps}
            buttonText={i18n.page.error.sessionExpired.login}
            onButtonClick={handleClick}
            hideCustomerServiceText={true}
            dataLayerErrorType={DataLayerErrorType.SESSION_EXPIRED_ERROR}
        />
    );
};
